module.exports = __webpack_public_path__ + "media/barometer_linkedin/purple-ombre-background-64c4adfa.png";